<section class="mt-3">

    <div class="row">
        
    </div>

    <!--Grid row-->
    <div class="row">

        <!--Grid column-->
        <div class="col-xl-3 col-md-6 mb-r">
            
            <mdb-card cascade="true" class="cascading-admin-card h-100">
                
                <div class="admin-up">
                    <mdb-icon fas icon="chart-line" class="dooya-green"></mdb-icon>
                    <div class="data">
                        <p>Total profit for {{year}}</p>
                        <h4 *ngIf="!busy"><strong>R {{totalYearProfit | number}}</strong></h4>
                        <app-loading [busy]="busy"></app-loading>
                    </div>
                </div>

                <mdb-card-body>
                    <div class="data">
                        <p>Profit for {{month}}</p>
                        <h4 *ngIf="!busy">R {{totalMonthProfit | number}}</h4>
                        <app-loading [busy]="busy"></app-loading>
                    </div>
                </mdb-card-body>

                <mdb-card-footer style="text-align: right">
                    <p><small class="text-black-50">As of {{today}} today</small></p>
                </mdb-card-footer>

            </mdb-card>

        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-xl-3 col-md-6 mb-r pt-xs-3 pt-md-3 pt-xl-0">

            <mdb-card cascade="true" class="cascading-admin-card h-100">

                <div class="admin-up">
                    <mdb-icon fas icon="chart-pie" class="light-blue lighten-1"></mdb-icon>
                    <div class="data">
                        <p>SDA available</p>
                        <h4 *ngIf="!busy"><strong>R {{sdaAvailable | number}}</strong></h4>
                        <app-loading [busy]="busy"></app-loading>
                    </div>
                </div>
                <mdb-card-body>
                    <p *ngIf="sdaConfigError" class="text-danger"><small>SDA data unavailable</small></p>
                    <div *ngIf="!sdaConfigError" class="progress">
                        <div class="progress-bar dooya-green" role="progressbar"
                            [ngStyle]="{'width': sdaRemainingPercentage + '%'}" aria-valuenow="25" aria-valuemin="0"
                            aria-valuemax="100"></div>
                    </div>
                    <p class="m-0">{{ sdaRemainingMessage }}</p>
                </mdb-card-body>
                
                <mdb-card-footer>
                    <table class="w-100" style="font-size: 0.75rem;">
                        <tbody>
                            <tr>
                                <td class="text-black-50 py-0">{{sarsSdaLabel}}</td>
                                <td class="text-black-50 py-0 text-right">{{sarsSdaValue}}</td>
                            </tr>
                            <tr>
                                <td class="text-black-50 py-0">{{adminSdaLabel}}</td>
                                <td class="text-black-50 py-0 text-right">{{adminSdaValue}}</td>
                            </tr>
                            <tr>
                                <td class="text-black-50 py-0">{{sdaTradedLabel}}</td>
                                <td class="text-black-50 py-0 text-right">{{sdaTradedValue}}</td>
                            </tr>
                            <tr style="border-top: 1px solid #dee2e6;">
                                <td class="text-black-50 py-0">{{sdaTotalLabel}}</td>
                                <td class="text-black-50 py-0 text-right">{{sdaTotalValue}}</td>
                            </tr>
                        </tbody>
                    </table>
                </mdb-card-footer>

            </mdb-card>

        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-xl-3 col-md-6 mb-r pt-xs-3 pt-md-3 pt-xl-0">
            
            <mdb-card cascade="true" class="cascading-admin-card h-100">
                
                <div class="admin-up">
                    <mdb-icon fas icon="chart-bar" class="red accent-2"></mdb-icon>
                    <div class="data">
                        <p>FIA available</p>
                        <h4 *ngIf="!busy"><strong>R {{fiaAvailable | number}}</strong></h4>
                        <app-loading [busy]="busy"></app-loading>                        
                    </div>
                </div>
                
                <mdb-card-body>
                    <p *ngIf="fiaConfigError" class="text-danger"><small>FIA data unavailable</small></p>
                    <div *ngIf="!fiaConfigError" class="progress">
                        <div class="progress-bar dooya-green" role="progressbar"
                            [ngStyle]="{'width': fiaUsedPercentage + '%'}" aria-valuenow="25" aria-valuemin="0"
                            aria-valuemax="100"></div>
                    </div>                    
                    <p class="m-0">{{ fiaUsedMessage }}</p>
                </mdb-card-body>
                
                <mdb-card-footer>
                    <table class="w-100" style="font-size: 0.75rem;">
                        <tbody>
                            <tr>
                                <td class="text-black-50 py-0">{{sarsFiaLabel}}</td>
                                <td class="text-black-50 py-0 text-right">{{sarsFiaValue}}</td>
                            </tr>
                            <tr>
                                <td class="text-black-50 py-0">{{adminFiaLabel}}</td>
                                <td class="text-black-50 py-0 text-right">{{adminFiaValue}}</td>
                            </tr>
                            <tr>
                                <td class="text-black-50 py-0">{{fiaTradedLabel}}</td>
                                <td class="text-black-50 py-0 text-right">{{fiaTradedValue}}</td>
                            </tr>
                            <tr style="border-top: 1px solid #dee2e6;">
                                <td class="text-black-50 py-0">{{fiaAvailableLabel}}</td>
                                <td class="text-black-50 py-0 text-right">{{fiaAvailableValue}}</td>
                            </tr>
                        </tbody>
                    </table>
                </mdb-card-footer>
                
            </mdb-card>
            
        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-xl-3 col-md-6 mb-r pt-xs-3 pt-md-3 pt-xl-0">
            
            <mdb-card cascade="true" class="cascading-admin-card h-100">
                
                <div class="admin-up">
                    <mdb-icon fas icon="file-invoice-dollar" class="dooya-yellow"></mdb-icon>
                    <div class="data">
                        <p>Total AIT Pin Balance</p>
                        <h4 *ngIf="!busy"><strong>R {{ this.totalPinBalance | number}}</strong></h4>
                        <app-loading [busy]="busy"></app-loading>                        
                    </div>
                </div>

                <mdb-card-body>                
                </mdb-card-body>

                <mdb-card-footer class="text-right">
                    <button mdbBtn color="dooya-action" size="sm" class="my-0 p" (click)="showFiaPins()">View My FIA Pins</button>
                </mdb-card-footer>
                
            </mdb-card>
            
        </div>
        <!--Grid column-->

    </div>
    <!--Grid row-->

</section>

<app-fia-pins [(showMe)]="showFiaPinsModal"></app-fia-pins>